export default __webpack_public_path__ + "static/media/sec4.845c61a0.svg";